<template>
    <div style="background-color:#fff" >
      <!-- <van-search v-model="theme" shape="round" background="#4fc08d" placeholder="请输入搜索关键词"  show-action>
        <template #label>
          <div >{{type}}</div>
        </template>
        <template #action >
          <div @click="onSearch" >搜索</div>
        </template>
      </van-search> -->
      <van-sticky :offset-top="0 " >
        <mini_head_top> </mini_head_top>
      </van-sticky>
      <van-row  type="flex"  justify="space-between" style="margin: auto; padding: auto; margin-top: 10px; width: 100%;text-align: left">
        <van-row>
          <span style="margin-left: 5px; height:16px;width:10px;background:#38e8eb; display: inline-block"> </span>
          <span style="font-size:16px;  font-weight:700">安全知识</span>
        </van-row>
        <el-link style="margin-right: 10px;" type="primary" @click.native="goHome()">主页 <i class= "el-icon-s-home"> </i></el-link>
      </van-row >
      <div style="height:calc(80vh - 40px);overflow: auto;">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad">
       <van-cell
        v-for="item in knList" :key="item.id" 
         @click="viewKnOne(item.id)" >

        <template #title>
          <van-row>
            <van-col span="16"  style="overflow: hidden;  ">{{ item.theme }}</van-col>
            <van-col span="8"   style="overflow: hidden; text-overflow: ellipsis;  white-space: nowrap;">{{ item.createTime }}</van-col>
          </van-row>
          </template>
        </van-cell>
       
      </van-list>
    </div>
    </div>
  </template>
  <script>
    import axios from  '@/api/axiosConfig'
    import mini_head_top from "@/mini_pages/mini_head_top"
    import {MESSAGE_DURATION } from  '@/api/constant'
    export default {
      name : 'mini_kn_list',
      data () {
        return {
          theme:'',
          pageNo :0,
          totalPageSize : 0,
          type : "主题",
          knList: [],
          loading: false,
          finished: false
        }
      },
      methods: {
        goHome(){
          this.$router.push({path:'/mini_index'})
        },
        viewKnOne(id){
          this.$router.push( {path: '/mini_view_editor', query: { id: id,fileType:'安全知识' }})
        },
        onSearch(){
          setTimeout(() => {
            this.knListLoad(1)
          }, 200)
        },
        onLoad() {
          setTimeout(() => {
            this.knListLoad( (this.pageNo  + 1))
          }, 200)
        },
       knListLoad(pageNo){
          let url = "/bc/exa/kn/knPage"
          let dat0 = {
            pageSize: 20,
            theme : this.theme,
            pageNo:pageNo,
            active: 1,
            adminInfInvoke :false
          }
          axios.post(url, dat0).then((response) => {
            
            this.pageNo = pageNo
            if (response.data.code === 0) {
              let dat = response.data.data
              if(dat.data.length !== 0){
                  if(pageNo == 1){
                    this.knList = [];
                  }
                  dat.data.forEach(t=>this.knList.push(t))
                  if( dat.data.length <dat.pageSize ){
                    this.finished = true;
                  }
              } else {
                this.finished = true
                if(pageNo == 1){
                  this.$message({
                    showClose: true,
                    message: '未查询到安全知识信息！',
                    type: 'info',
                    duration: MESSAGE_DURATION
                  })
                }
                
              }
            }else{
              this.finished = true
     
              this.$message({
                showClose: true,
                message: response.data.message,
                type: 'error',
                duration: MESSAGE_DURATION
              })
            }
            this.loading = false;
            }).catch((err)=>{
              //this.loading = false
              this.pageNo = pageNo -1
              this.loading = false;
              this.$message({
                showClose: true,
                message: err.message,
                type: 'error',
                duration: MESSAGE_DURATION
              })
            });
        },
      },
      created(){
        //setTimeout(()=>{ this.knListLoad(1),200})
      },
      components :{

        mini_head_top
      }
    }
  </script>
  
  <style lang="less" scoped>
      
  </style>
  


// WEBPACK FOOTER //
// src/mini_pages/mini_kn_list.vue